var map = {
	"./answer-block.webp": "a602",
	"./answer-capacitor.webp": "35ee",
	"./answer-ceramic.webp": "171c",
	"./block-blue.webp": "7ad3",
	"./block-green.webp": "c961",
	"./block-magenta.webp": "536d",
	"./block-purple.webp": "93bb",
	"./block-teal.webp": "8d9b",
	"./block-yellow.webp": "0bf6",
	"./capacitor-blue.webp": "9a42",
	"./capacitor-green.webp": "b40c",
	"./capacitor-magenta.webp": "967a",
	"./capacitor-purple.webp": "cb8c",
	"./capacitor-teal.webp": "212f",
	"./capacitor-yellow.webp": "cd65",
	"./ceramic-blue.webp": "3d3b",
	"./ceramic-green.webp": "9e8d",
	"./ceramic-magenta.webp": "909e",
	"./ceramic-purple.webp": "626c",
	"./ceramic-teal.webp": "bc87",
	"./ceramic-yellow.webp": "efdb",
	"./cloud.webp": "f7f6",
	"./lights.webp": "4c56"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2673";